module.exports = __webpack_public_path__ + "img/mhd_item_08.82288eb6.png";